import { render } from "./about.vue?vue&type=template&id=94f28808"
const script = {}

import exportComponent from "/Users/a123/Documents/HBuilderProjects/limit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__